module.exports = __webpack_public_path__ + "img/stayDiacrisis.41fb7fa6.svg";